'use client';

import { FEATURE_FLAG_KEYS, ELEMENT_TYPE } from 'shop-ui/constants';
import { combineComponent } from 'shop-ui/tools/combineComponent';
import { GRID_LAYOUT_TYPE } from 'shop-ui/section/Grid/rules';
import { createProductImageGallery } from 'shop-ui/component/ProductImageGallery';
import { createProductInfoGroup } from 'shop-ui/component/ProductInfoGroup';
import { createProductGiveaway } from 'shop-ui/component/ProductGiveaway';
import { createProductDescription } from 'shop-ui/component/ProductDescription';
import i18n from '@shared/i18n';
import { type LayoutNodeStyleMap } from 'app/shop-ui/types';

export enum OFFICIAL_PAGE_SECTION_KEY {
    PRODUCT_CART_MODULE = 'page-section-product-cart-module',
    PRODUCT_GIVEAWAY = 'page-section-product-giveaway',
    PRODUCT_DESCRIPTION = 'page-section-product-description',
}

export const officialPageSectionList = [
    {
        name: OFFICIAL_PAGE_SECTION_KEY.PRODUCT_CART_MODULE,
        type: ELEMENT_TYPE.PRODUCT_INFO_GROUP,
        content: i18n.gettext('主商品'),
        version: 1,
    },
    {
        name: OFFICIAL_PAGE_SECTION_KEY.PRODUCT_DESCRIPTION,
        type: ELEMENT_TYPE.PRODUCT_DESCRIPTION,
        content: i18n.gettext('商品段落'),
        version: 1,
    },
];

export function createProductCartModule(
    imageGalleryPresetStyle?: LayoutNodeStyleMap[string],
    productInfoGroupPresetStyle?: LayoutNodeStyleMap[string]
) {
    const productImageGallery = createProductImageGallery(imageGalleryPresetStyle);

    const productInfoGroup = createProductInfoGroup(productInfoGroupPresetStyle);

    return combineComponent(
        i18n.gettext('商品資訊組合'),
        [productImageGallery, productInfoGroup],
        {
            primaryGridType: GRID_LAYOUT_TYPE.SPLIT_H_2C,
            secondaryGridType: GRID_LAYOUT_TYPE.SINGLE_CELL,
            primaryGridPresetStyle: {
                [FEATURE_FLAG_KEYS.MIN_HEIGHT]: '500px',
                [FEATURE_FLAG_KEYS.BACKGROUND_COLOR]: '',
                [FEATURE_FLAG_KEYS.GRID_GAP]: '40px',
                [FEATURE_FLAG_KEYS.FIXED_SCREEN_HEIGHT]: false,
                [FEATURE_FLAG_KEYS.PADDING_TOP]: '36px',
                [FEATURE_FLAG_KEYS.PADDING_BOTTOM]: '36px',
            },
            secondaryGridPresetStyle: [
                {
                    [FEATURE_FLAG_KEYS.GRID_ALIGNMENT]: 'start',
                },
            ],
            shouldWrap: true,
            deletable: false,
        }
    );
}

export const createProductCardGiveaway = (
    productGiveawayPresetStyle?: LayoutNodeStyleMap[string]
) => {
    const productGiveaway = createProductGiveaway(productGiveawayPresetStyle);

    return combineComponent(i18n.gettext('加價購'), [productGiveaway], {
        primaryGridType: GRID_LAYOUT_TYPE.SINGLE_CELL,
        secondaryGridType: GRID_LAYOUT_TYPE.SINGLE_CELL,
        primaryGridPresetStyle: {
            [FEATURE_FLAG_KEYS.MIN_HEIGHT]: '500px',
            [FEATURE_FLAG_KEYS.GRID_ROW_1]: '0.1fr',
            [FEATURE_FLAG_KEYS.GRID_ROW_2]: '0.9fr',
            [FEATURE_FLAG_KEYS.BACKGROUND_COLOR]: '',
            [FEATURE_FLAG_KEYS.GRID_GAP]: '20px',
            [FEATURE_FLAG_KEYS.FIXED_SCREEN_HEIGHT]: false,
            [FEATURE_FLAG_KEYS.PADDING_TOP]: '36px',
            [FEATURE_FLAG_KEYS.PADDING_BOTTOM]: '36px',
        },
        secondaryGridPresetStyle: [
            {},
            {
                [FEATURE_FLAG_KEYS.GRID_ALIGNMENT]: 'end',
            },
        ],
        shouldWrap: true,
        deletable: true,
    });
};

export const _createProductDescription = () => {
    const productDescription = createProductDescription();

    return combineComponent(i18n.gettext('商品段落'), [productDescription], {
        primaryGridType: GRID_LAYOUT_TYPE.SINGLE_CELL,
        secondaryGridType: GRID_LAYOUT_TYPE.SINGLE_CELL,
        primaryGridPresetStyle: {
            [FEATURE_FLAG_KEYS.PADDING_TOP]: '20px',
            [FEATURE_FLAG_KEYS.PADDING_BOTTOM]: '20px',
        },
        secondaryGridPresetStyle: [],
        shouldWrap: true,
        deletable: false,
    });
};

export const officialPageSectionGenMap = {
    [OFFICIAL_PAGE_SECTION_KEY.PRODUCT_CART_MODULE]: createProductCartModule,
    [OFFICIAL_PAGE_SECTION_KEY.PRODUCT_DESCRIPTION]: _createProductDescription,
};
